import moment from 'moment'

import { DAYS_IN_WEEK, HOURS_IN_DAY } from './weekLayoutConstants'

const INITIAL_OFFSET = 0

/**
 * Round to decimal
 */
function round(num: number) {
  return Math.round(num * 10) / 10
}

type Params = {
  item: {
    start: string
    end: string
  }
  timeRange: {
    start: string
    end: string
  }
}
/**
 * Return a size in day (max: 7) for a given date range.
 * The size is scoped on a week range (7 days)
 *
 * Strict option throws an error when the result is equal to 0.
 * That means the given start and end date are not between start and end of the week
 */
function getWeekSize({ item, timeRange }: Params) {
  /**
   * Get an amount of days diff between rest start/end and the start of the week
   */
  const diff = {
    start: moment(item.start).diff(timeRange?.start, 'hours') / HOURS_IN_DAY,
    end: moment(item.end).diff(timeRange?.start, 'hours') / HOURS_IN_DAY
  }

  // If diff.start is negative or equals 0 it means the rest starts before the week
  // So we should set the start-offset to 0
  const isBeforeStartOfWeek = diff.start <= 0
  const startOffset = isBeforeStartOfWeek
    ? INITIAL_OFFSET
    : Math.abs(diff.start)

  // If diff.end is larger or equals to 7 (max number of days) it means the rest ends after the week
  // So we should set the end-offset to 7
  const isAfterEndOfWeek = diff.end >= DAYS_IN_WEEK
  const endOffset = isAfterEndOfWeek ? DAYS_IN_WEEK : diff.end

  const size = endOffset - startOffset
  return round(size)
}

export default getWeekSize
